// TODO: gray toneを整理する
const Pallet = {
  white: `#fff`,
  black: `#423F3C`,
  darker: `#131110`,
  dark: `#41423C`,
  gray: `#f5f5f5`,
  gray2: `#999`,
  gray3: `#efefef`,
  gray4: `#D2D0CF`,
  grayMid: `#716760`,
  lightGray: `#faf8f6`,
  creamGray: `#faf8f6`,
  creamGray2: `#efebe7`,
  littleBrightGray: `#969696`,
  orange: `#ff6400`,
  subOrange: `#ffD5C2`,
  lightOrange: `#fff0eB`,
  purple: `#86a1f3`,
  lightPurple: `#c3dfdd`,
  red: `#ff6673`,
  lightRed: `#f5c6c3`,
  darkBlue: `#0F78D8`,
  lightBlue: `#76C8C8`,
};

const Semantics = {
  darkerText: Pallet.darker,
  darkText: Pallet.dark,
  defaultText: Pallet.black,
  lightText: Pallet.grayMid,
  whiteText: Pallet.white,
  defaultBg: Pallet.creamGray,
  brand: Pallet.orange,
  brandAccent: Pallet.purple,
  brandGradient: `linear-gradient(to bottom right, #EC7F18 30%, #EC553F)`,
  seminarCtaGradient: `linear-gradient(
    270deg,
    rgb(234, 51, 117) -73%,
    rgb(234, 53, 114) -69.4%,
    rgb(235, 70, 86) -31.72%,
    rgb(236, 81, 69) 1.32%,
    rgb(236, 63, 80) 25.96%,
    rgb(236, 131, 23) 100%
  )`,
  bgGrayGradient: `linear-gradient(180deg, ${Pallet.white} 10%, ${Pallet.creamGray} 60%)`,
  error: Pallet.red,
  border: Pallet.gray4,
};

export const colors = {
  ...Pallet,
  ...Semantics,
};
